// src/components/QuestionRow.js
import React from 'react';

// Normalize difficulty to exactly Easy/Medium/Hard
const normalizeDifficulty = (d) => {
  const s = String(d || '').trim().toLowerCase();
  if (s === 'easy') return 'Easy';
  if (s === 'medium') return 'Medium';
  if (s === 'hard' || s === 'difficult') return 'Hard';
  return '';
};

// Format correct answer like "A / B" if multiple variants are stored
const formatCorrect = (val) =>
  String(val || '')
    .split(/[,\s|]+/) // Removed '/' from the split list
    .map(t => t.trim().toUpperCase())
    .filter(Boolean)
    .join(', ');

const styles = {
  row: {
    cursor: 'pointer',
    borderBottom: '1px solid #f3f4f6',
    transition: 'background-color 0.12s ease, transform 0.08s ease',
  },
  cell: {
    padding: '8px 10px',
    fontSize: '13px',
    color: '#111827',
    verticalAlign: 'top',
    whiteSpace: 'nowrap',
  },
  statusCorrect: { color: '#15803d', fontWeight: 700 },
  statusIncorrect: { color: '#b91c1c', fontWeight: 700 },
  link: {
    fontSize: 12,
    fontWeight: 800,
    color: '#1d4ed8',
    textDecoration: 'none',
    padding: '6px 10px',
    borderRadius: 999,
    border: '1px solid #bfdbfe',
    background: 'linear-gradient(90deg, #dbeafe, #e0e7ff)',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
  },
  linkMuted: { fontSize: 12, color: '#94a3b8' },
};

export default function QuestionRow({ item, onOpen }) {
  const statusStyle = item?.isCorrect ? styles.statusCorrect : styles.statusIncorrect;

  return (
    <tr
      style={{ ...styles.row, backgroundColor: item?.isCorrect ? '#f0fdf4' : '#fef2f2' }}
      onClick={() => onOpen?.(item)}
      title="Click to preview this question"
    >
      <td style={styles.cell}>{item?.questionNumber ?? '—'}</td>
      <td style={{ ...styles.cell, ...statusStyle }}>{item?.isCorrect ? 'Correct' : 'Incorrect'}</td>
      <td style={styles.cell}>{item?.category || '-'}</td>
      <td style={styles.cell}>{item?.subcategory || '-'}</td>
      <td style={styles.cell}>{normalizeDifficulty(item?.difficulty)}</td>
      <td style={styles.cell}>{String(item?.studentAnswer || '').toUpperCase() || '-'}</td>
      <td style={styles.cell}>{formatCorrect(item?.correctAnswer)}</td>
      <td style={styles.cell}>
        {item?.explanationLink ? (
          <a
            href={item.explanationLink}
            target="_blank"
            rel="noreferrer"
            style={styles.link}
            onClick={(e) => e.stopPropagation()}
            title="Open explanation in a new tab"
          >
            Open
          </a>
        ) : (
          <span style={styles.linkMuted}>—</span>
        )}
      </td>
    </tr>
  );
}
